import {
  IonButton,
  IonButtons,
  IonFooter,
  IonHeader,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonListHeader,
  IonText,
  IonToggle,
  IonToolbar,
} from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IDriversLicenseScannerState } from '../store/driversLicenseScanner.types'
import { DriversLicenseScannerService } from '../services/driversLicenseScanner.service'
import { convertWeightString, convertZIPString } from '../../../utilities/string.util'
import LabelComponent from '../../../components/label/Label.component'

interface IDriversLicenseResultsViewProps {
  dlScanner: IDriversLicenseScannerState
  driversLicenseScannerService: DriversLicenseScannerService
  onClose: () => void
  onRetry: () => void
}
const DriversLicenseResultsView: React.FC<IDriversLicenseResultsViewProps> = (
  props: IDriversLicenseResultsViewProps
) => {
  const { dlScanner, driversLicenseScannerService, onClose, onRetry } = props
  const { licenseInfo, licenseKeys } = dlScanner
  const { t } = useTranslation()

  const [isToggleAll, setToggleAll] = useState(true)
  const [keys, setKeys] = useState(licenseKeys)

  useEffect(() => {
    document.querySelector('body')?.classList.remove('transparent-body')

    return () => {
      document.querySelector('body')?.classList.add('transparent-body')
    }
  })

  const onToggle = (licenseKey: string) => {
    const _licenseKeys = driversLicenseScannerService.getLicenseKeys(licenseKey, keys)
    setKeys(_licenseKeys)
  }

  const onToggleAll = () => {
    setToggleAll(!isToggleAll)

    const _licenseKeys = driversLicenseScannerService.getToggleAllLicenseKeys(!isToggleAll, licenseInfo)
    setKeys(_licenseKeys)
  }

  const onSave = () => {
    onClose()
  }

  const onCancel = () => {
    onRetry()
  }

  const formatContent = (key: any, content: any) => {
    if (key === 'DAW') {
      return convertWeightString(content)
    } else if (key === 'DAK') {
      return convertZIPString(content)
    } else {
      return content
    }
  }

  const renderLicenseInfo = (key: any) => {
    // @ts-ignore
    const li: any = licenseInfo[key]
    const { description, content } = li

    const dataPreview = `${description}: ${formatContent(key, content)}`

    if (!driversLicenseScannerService.isToggleKey(key)) return null

    return (
      <IonItem data-testid={key} key={key}>
        <IonToggle
          data-testid={`Toggle-${key}`}
          slot='start'
          checked={keys && keys.indexOf(key) !== -1}
          onIonChange={onToggle.bind(null, key)}
        />

        <LabelComponent isPHI label={dataPreview} size={3} />
      </IonItem>
    )
  }

  return (
    <>
      <IonHeader className='ion-no-border'>
        <IonToolbar color='light'>
          <IonListHeader color='light'>
            <IonLabel>{t('dl.DriverLicense')}</IonLabel>
          </IonListHeader>
        </IonToolbar>
      </IonHeader>

      <IonList id='driver-modal' lines='full'>
        <IonItemDivider color='light' className='ion-padding'>
          <IonLabel className='grid-item-divider-label' color='medium'>
            {t('dl.SelectWhatYouWantToImport')}
          </IonLabel>
        </IonItemDivider>
        <IonItemDivider color='light' className='ion-padding'>
          <IonText className='ion-text-uppercase' color='medium'>
            {t('dl.Demographics')}
          </IonText>
        </IonItemDivider>
        <IonItem>
          <IonToggle slot='start' checked={isToggleAll} onIonChange={onToggleAll} />
          <IonLabel>
            <IonText>
              <h3>{t('dl.ImportAll')}</h3>
            </IonText>
          </IonLabel>
        </IonItem>

        {licenseInfo && Object.keys(licenseInfo).map(renderLicenseInfo)}

        {(!licenseInfo || !Object.keys(licenseInfo).length) && (
          <IonText data-testid='ScanningError'>{t('dl.ScanningError')}</IonText>
        )}
      </IonList>
      <IonFooter className='ion-no-border'>
        <IonToolbar color='light' className='p-10'>
          <IonButtons>
            <IonButton data-testid='Cancel' className='btn btn-secondary mr-8' expand='block' onClick={onCancel}>
              {t('dl.Cancel')}
            </IonButton>
            <IonButton data-testid='Save' className='btn btn-primary' expand='block' onClick={onSave}>
              {t('dl.Save')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </>
  )
}

export default DriversLicenseResultsView
